import { Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import MaxWidthContainer from "../MaxWidthContainer";
import Navigation from "../Navigation";
import MyHealthMenu from "@/features/HealthScore/components/MyHealthMenu";
import {
  FeatureToggleIdentifier,
  isFeatureEnabled,
} from "@/services/feature-toggle-adapter";

export default function BottomNavigation() {
  const isTrendedVitalsEnabled = isFeatureEnabled(
    FeatureToggleIdentifier.ENABLE_TRENDED_VITALS
  );
  const { t } = useTranslation();

  return (
    <Stack
      direction="row"
      sx={{
        position: "fixed",
        left: "50%",
        transform: "translateX(-50%)",
        bottom: 0,
        width: "100%",
        p: (theme) => theme.spacing(1),
        pt: 0,
        pb: "calc(8px + env(safe-area-inset-bottom, 0px))",
        zIndex: 2,
      }}
      component="nav"
      aria-label={t("BottomNavigation.label")}
    >
      <MaxWidthContainer>
        {isTrendedVitalsEnabled ? <MyHealthMenu /> : <Navigation />}
      </MaxWidthContainer>
    </Stack>
  );
}
